import api from '../lib/api';
import type { AlertResume, AlertResumeFilters, AlertResumeResponse } from '../types/alertResume';

export const alertResumeService = {
  async getAll(filters?: AlertResumeFilters): Promise<AlertResumeResponse> {
    const params = new URLSearchParams();

    if (filters?.resolved !== undefined) params.append('resolved', String(filters.resolved));
    if (filters?.user_account_id !== undefined) params.append('user_account_id', String(filters.user_account_id));
    if (filters?.alert_type) params.append('alert_type', filters.alert_type);
    if (filters?.page) params.append('page', String(filters.page));
    if (filters?.limit) params.append('limit', String(filters.limit));

    const queryString = params.toString();
    const url = `/alert-resumes${queryString ? `?${queryString}` : ''}`;

    const response = await api.get(url);
    return {
      data: response.data.data || [],
      pagination: response.data.pagination || { total: 0, per_page: 20, current_page: 1, last_page: 1 },
    };
  },

  async getById(id: number) {
    const response = await api.get(`/alert-resumes/${id}`);
    return response.data.data;
  },

  async create(data: Partial<AlertResume>) {
    const response = await api.post('/alert-resumes', data);
    return response.data.data;
  },

  async update(id: number, data: Partial<AlertResume>) {
    const response = await api.put(`/alert-resumes/${id}`, data);
    return response.data.data;
  },

  async delete(id: number) {
    const response = await api.delete(`/alert-resumes/${id}`);
    return response.data.data;
  },

  async markAsResolved(id: number) {
    const response = await api.patch(`/alert-resumes/${id}/resolve`);
    return response.data.data;
  },
};
